<div class="edit-project-dialog-container">
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    @if (data.hasClose) {
      <button
        mat-icon-button
        [mat-dialog-close]="false"
        class="close-button"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <div class="modal-content">
    @if (data.dialogData.activeForm === "notebookCreate") {
      <app-notebook-form
        formAlign="column"
        workMode="create"
      ></app-notebook-form>
    }
    @if (data.dialogData.activeForm === "notebookEdit") {
      <app-notebook-form
        formAlign="column"
        workMode="update"
      ></app-notebook-form>
    }
    @if (data.dialogData.activeForm === "projectCreate") {
      <app-project-form
        [project]="data.dialogData?.model"
        formAlign="column"
        workMode="create"
      ></app-project-form>
    }
    @if (data.dialogData.activeForm === "projectEdit") {
      <app-project-form
        [project]="data.dialogData?.model"
        formAlign="column"
        workMode="update"
      ></app-project-form>
    }
  </div>
</div>
